import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware, { END } from "redux-saga";

import { ENV } from "./envconfig";
import { default as reducer } from "./rootReducer";

export default function configureAppStore(initialState) {
    if (process.env.CONF_ENV !== ENV.PRODUCTION) {
        return configureDev(initialState);
    } else {
        return configureProd(initialState);
    }
}
function configureProd() {
    const sagaMiddleware = createSagaMiddleware();
    const store = createStore(reducer, applyMiddleware(sagaMiddleware));

    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);
    return store;
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
function configureDev(initialState) {
    const sagaMiddleware = createSagaMiddleware();
    const store = createStore(reducer, initialState, composeEnhancers(applyMiddleware(sagaMiddleware)));

    if (module.hot) {

        module.hot.accept("./rootReducer", () => {
            const nextRootReducer = require("./rootReducer").default;
            store.replaceReducer(nextRootReducer);
        });
    }
    store.runSaga = sagaMiddleware.run;
    store.close = () => store.dispatch(END);
    return store;
}
